import apiRoutes from './api.routes';
import api from './api.service';
import ModelService from './model.service';

const TicketService = new ModelService(apiRoutes.tickets, '/tickets');

TicketService.modelName = 'Ticket';

TicketService.STATUS_OPEN = 1;
TicketService.STATUS_RESOLVED = 2;
TicketService.STATUS_URGENT = 3;

TicketService.ST_STATUS = 'status';

TicketService.getStatusList = t => ({
  [TicketService.STATUS_OPEN]: t('Open'),
  [TicketService.STATUS_URGENT]: t('Urgent'),
  [TicketService.STATUS_RESOLVED]: t('Resolved'),
});

TicketService.getData = params => api.catchError(async () => {
  const { data, headers: { 'x-total-count': count } } = await api.get(`${apiRoutes.tickets}`, params);
  return { data, count: parseInt(count, 10) };
});

TicketService.getStatusOptions = t => TicketService
  .prepareOptionsFromSimpleObject(TicketService.getStatusList(t));

TicketService.getStatusTitle = (status, t) => {
  const label = TicketService.getStatusList(t)[status];
  return label || '-';
};

TicketService.getColorByStatus = (status) => {
  switch (status) {
    case TicketService.STATUS_OPEN:
      return 1;
    case TicketService.STATUS_URGENT:
      return 2;
    case TicketService.STATUS_RESOLVED:
      return 3;
    default:
      return '';
  }
};

export default TicketService;



// WEBPACK FOOTER //
// ./src/services/ticket.service.js